import dom from '../../utils/dom';
import { loadModal } from '../../AsyncLoader';
import { confirmSelectedPaymentPlanBillingSchedule } from './confirmSelectedPaymentPlanSchedule';
import PaymentPlanSelectionOption from './PaymentPlanSelectionOption';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import PaymentPlanService from './PaymentPlanService';
import PaymentPlanErrorMessage from './PaymentPlanErrorMessage';

function getModalProperties() {
  const key = ComponentKeys.PAYMENT_PLANS;

  return {
    title: ContentStorage.get(key, 'ModalSubhead'),
    labelBtnSubmit: ContentStorage.get(key, 'ContinueButtonLabel'),
    labelBtnCancel: ContentStorage.get(key, 'CancelButtonLabel'),
  };
}

class PaymentPlanSelectionFormModal {
  /**
   * @param {HTMLFormElement} $form
   */
  constructor($form) {
    this.$form = $form;

    const $options = dom.findAllFrom(this.$form, '.tn-payment-plan-selection__billing-schedule');

    const options = $options.map(($option) => new PaymentPlanSelectionOption($option, this.onChange));

    this.selectedOption = options[0];

    dom.remove(this.$form);
    dom.unhide(this.$form);

    const $errorMessageContainer = dom.makeElement('div');

    dom.prepend($form, $errorMessageContainer);

    this.errorMessage = new PaymentPlanErrorMessage($errorMessageContainer);
  }

  /**
   * @param {PaymentPlanSelectionOption} option
   */
  onChange = (option) => {
    this.selectedOption.hideDetails();

    option.showDetails();

    this.selectedOption = option;
  };

  /**
   * @param {HTMLElement} $returnFocusTo
   */

  async getPaymentPlanSelection($returnFocusTo) {
    const Modal = await loadModal();

    const { title, labelBtnSubmit, labelBtnCancel } = getModalProperties();

    const modal = Modal.presentForm({
      $form: this.$form,
      title,
      labelBtnSubmit,
      labelBtnCancel,
      returnFocusTo: $returnFocusTo,
      beforeClose: () => {
        this.errorMessage.hide();
      },

      onSubmit: async () => {
        this.errorMessage.hide();

        const scheduleId = this.selectedOption.getId();

        const previewResponse = await PaymentPlanService.getPaymentPlanPreview(scheduleId);

        modal.enableForm();

        if (!previewResponse.isSuccessful) {
          this.errorMessage.show();

          modal.scrollToTop();

          return;
        }

        const { wasCancelled } = await confirmSelectedPaymentPlanBillingSchedule(previewResponse.html, scheduleId);

        if (wasCancelled) {
          modal.enableForm();
        }
      },
    });
  }
}

export default PaymentPlanSelectionFormModal;
